import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { faCalendar, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { firstValueFrom } from "rxjs";
import { Calibration } from "src/app/models/Calibration";
import { Certificate } from "src/app/models/Certificate";
import { DocType } from "src/app/models/Enums";
import { Service } from "src/app/models/Service";
import { Tool } from "src/app/models/Tool";
import { ToolBase } from "src/app/models/ToolBase";
import { ToolDetails } from "src/app/models/ToolDetails";
import { CompanyService } from "src/app/services/company.service";
import { LocationService } from "src/app/services/location.service";
import { ModalConfig, ModalService } from "src/app/services/modal.service";

import { ToolService } from "../../services/tool.service";
import { AuthService } from "./../../services/auth.service";
import { ScheduleService } from "./../../services/schedule.service";
import { CalibrationModalComponent } from "./../calibration-modal/calibration-modal.component";
import { DepartmentModalComponent } from "./../department-modal/department-modal.component";
import { LocationModalComponent } from "./../location-modal/location-modal.component";
import { ServiceModalComponent } from "./../service-modal/service-modal.component";
import { ToolNotesModalComponent } from "./../tool-notes-modal/tool-notes-modal.component";

@Component({
  selector: "app-tool-info",
  templateUrl: "./tool-info.component.html",
  styleUrls: ["./tool-info.component.scss"],
  standalone: false,
})
export class ToolInfoComponent implements OnInit {
  faCalendar = faCalendar;
  faPencilAlt = faPencilAlt;
  companyId: string;
  serialNumber: string;
  calibrationSchedule: Calibration;
  tool: Tool;
  serviceSchedule: Service;
  serviceFrequencyList: number[];
  nextServiceDate: Date;
  modalSaveIsLoading: boolean;
  certificate: Certificate;
  toolDetails: ToolDetails; // this prop is set by parent component

  constructor(
    private route: ActivatedRoute,
    private toolService: ToolService,
    public modalService: ModalService,
    public companyService: CompanyService,
    public locationService: LocationService,
    private scheduleService: ScheduleService,
    public authService: AuthService,
  ) {
    this.companyId = this.route.parent.snapshot.paramMap.get("company");
    this.serialNumber = this.route.parent.snapshot.paramMap.get("serialnumber");
    if (!this.companyId || !this.serialNumber) return;

    this.getLastCertificate();
  }
  ngOnInit(): void {
    this.setToolDetails();
  }

  setToolDetails() {
    this.tool = this.toolDetails.details;
    this.serviceSchedule = this.toolDetails.service;

    const localizedServiceInterval = this.scheduleService.intervals.find(
      (x) => x.id === this.serviceSchedule.interval,
    );

    this.serviceSchedule.localizedInterval = localizedServiceInterval?.localizedTitle;

    this.calibrationSchedule = this.toolDetails.calibration;

    const localizedCalibrationInterval = this.scheduleService.intervals.find(
      (x) => x.id === this.calibrationSchedule.interval,
    );

    this.calibrationSchedule.localizedInterval = localizedCalibrationInterval?.localizedTitle;

    this.nextServiceDate = this.serviceSchedule.nextDate;
  }

  /**
   * Gets the last certificate from CERTS table for current tool.
   */
  async getLastCertificate() {
    this.certificate = await firstValueFrom(
      this.toolService.getLastCertificate(new ToolBase(this.companyId, this.serialNumber)),
    );

    if (this.certificate) this.certificate.documentType = DocType.Certificate;
  }

  get calibrationStatusLabel() {
    return this.scheduleService.calibrationStatuses.find(
      (x) => x.id == this.calibrationSchedule.calibrationStatus,
    )?.title;
  }

  openLocationModal() {
    this.modalService.openDefaultModal(LocationModalComponent, this.tool);
  }

  openDepartmentModal() {
    this.modalService.openDefaultModal(DepartmentModalComponent, this.tool);
  }

  openNotesModal() {
    const config = new ModalConfig();
    config.width = "900px";
    config.data = this.tool;

    this.modalService.openModal(ToolNotesModalComponent, config);
  }

  openCalibrationModal() {
    this.modalService.openDefaultModal(CalibrationModalComponent, {
      tool: this.tool,
      calibration: this.calibrationSchedule,
    });
  }

  openServiceModal() {
    this.modalService.openDefaultModal(ServiceModalComponent, {
      tool: this.tool,
      calibration: this.serviceSchedule,
    });
  }
}
